import React from "react"

import Header from "../components/header"
import Footer from "../components/footer"

import "./layout.css"

import "@fortawesome/fontawesome-svg-core/styles.css"
import { config } from "@fortawesome/fontawesome-svg-core"

import BreadcrumbComponent, {
  BreadcrumbComponentProps,
} from "../components/BreadcrumbComponent"
import "bootstrap/dist/css/bootstrap.min.css"

config.autoAddCss = false

interface LayoutProps extends BreadcrumbComponentProps {
  children?: React.ReactNode
}

export const Layout = ({ children, pageContext }: LayoutProps) => {
  return (
    <div>
      <Header />
      <BreadcrumbComponent pageContext={pageContext} />
      {children}

      <Footer />
    </div>
  )
}
